import React, { useEffect, useMemo, useState } from 'react';
import { IPdfReportType, ReportInfoType } from '../../pages/report/type';
import ErrorInfo from '../../pages/report/component/errorInfo';
import Loading from '@/pages/dashboard/components/Loadings';
import { getLocale } from 'umi';
import { getPdfCos } from '@home/services/report';
import classNames from 'classnames';

const INIT_REPORT_INFO: ReportInfoType = {
  loading: true,
  noReport: false,
  errMsg: '',
  reportUrl: '',
};

export default (props: IPdfReportType) => {
  const { url, className = '', style = {}, onSuccess, onFail, apiUrl = '/api/v1/dashboard/cos/presigned_url'} = props || {};
  const [reportInfo, setReportInfo] = useState<ReportInfoType>(INIT_REPORT_INFO);
  const locale = getLocale();
  const isEn = locale === 'en-US';

  useEffect(() => {
    const openIframeReport = () => {
      setReportInfo({
        ...INIT_REPORT_INFO,
      });
  
      const params = {
        url
      };
  
      getPdfCos(params, apiUrl).then((data) => {
        setReportInfo({
          loading: false,
          reportUrl: `${data}#view=fitH,top&navpanes=0`,
          noReport: !data,
          errMsg: data?.msg || ''
        });
        onSuccess?.();
      }).catch(()=>{
        setReportInfo({
          ...INIT_REPORT_INFO,
          loading: false,
          noReport: true,
        });
        onFail?.();
      });
    };
    openIframeReport();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  const errorInfo = useMemo(() => {
    if (reportInfo.noReport) {
      return <ErrorInfo isEn={isEn} />;
    }
    return null;
  }, [reportInfo, isEn]);

  return (
    <>
      {reportInfo.loading ? (
        <Loading />
      ) : (
        <>
          {errorInfo || (
            <div className={classNames('dtb-db-iframe-wrap db-report-pdf', className)} style={style}>
              <iframe
                title="pdf"
                className='dtb-db-iframe'
                src={reportInfo.reportUrl}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};
